import * as Library from '../../../../lib/core/library/index';

export class Media {
  public type: string;
  public href: string;
  public size: string;

  /*
   * Constructor()
   */
  constructor();
  constructor(options: object);
  constructor(options?: any) {
    this.type = Library.init(options, 'type');
    this.href = Library.init(options, 'href');
    this.size = Library.init(options, 'size');
  }
}
